export default "https://cdn-static.gokick.com/assets/37f77ff38331b66adda42c842f0b505f9084d1fd/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";